import React from 'react';

function PrerenderLogo() {
  return (
    <svg width="170" height="26" viewBox="0 0 170 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.1368 1.558L8.1522 7.07405L7.12685 5.93938C6.67865 5.44339 6.67865 4.63923 7.12685 4.14324L10.4884 0.423328C10.9366 -0.0726643 11.6633 -0.0726626 12.1115 0.423329L13.1368 1.558Z"
        fill="#2DA01D"
      />
      <path
        d="M8.13308 18.0106L13.1177 23.5267L12.1115 24.6402C11.6633 25.1362 10.9366 25.1362 10.4884 24.6402L7.12685 20.9203C6.67864 20.4243 6.67864 19.6202 7.12685 19.1242L8.13308 18.0106Z"
        fill="#2DA01D"
      />
      <path
        d="M6.36445 9.05241L4.89192 10.6819C3.95815 11.7153 3.95816 13.3906 4.89192 14.4239L6.33057 16.016L5.32077 17.1334C4.87256 17.6294 4.14587 17.6294 3.69767 17.1334L0.336154 13.4135C-0.112052 12.9175 -0.112051 12.1134 0.336155 11.6174L3.69767 7.89745C4.14588 7.40146 4.87256 7.40146 5.32077 7.89745L6.36445 9.05241Z"
        fill="#2DA01D"
      />
      <path
        d="M19.4932 1.62551L14.5086 7.14157L13.4223 5.93938C12.9741 5.44339 12.9741 4.63923 13.4223 4.14324L16.7838 0.423328C17.232 -0.0726643 17.9587 -0.0726626 18.4069 0.423329L19.4932 1.62551Z"
        fill="#2DA01D"
      />
      <path
        d="M14.4895 17.9431L19.4741 23.4592L18.4069 24.6402C17.9587 25.1362 17.232 25.1362 16.7838 24.6402L13.4222 20.9203C12.974 20.4243 12.974 19.6202 13.4223 19.1242L14.4895 17.9431Z"
        fill="#2DA01D"
      />
      <path
        d="M12.7209 9.11992L11.3093 10.6819C10.3756 11.7153 10.3756 13.3906 11.3093 14.4239L12.687 15.9484L11.6162 17.1334C11.168 17.6294 10.4413 17.6294 9.99307 17.1334L6.63156 13.4135C6.18335 12.9175 6.18335 12.1134 6.63156 11.6174L9.99308 7.89745C10.4413 7.40146 11.168 7.40146 11.6162 7.89745L12.7209 9.11992Z"
        fill="#2DA01D"
      />
      <path
        d="M23.3101 0.371995C23.7583 -0.123997 24.485 -0.123999 24.9332 0.371994L34.5879 11.0561C35.335 11.8828 35.335 13.2231 34.5879 14.0497L24.9332 24.7339C24.485 25.2299 23.7583 25.2299 23.3101 24.7339L13.1142 13.451C12.666 12.955 12.666 12.1508 13.1142 11.6549L23.3101 0.371995Z"
        fill="#2DA01D"
      />
      <path
        d="M47.1916 20.2004V15.0733H50.8107C53.6543 15.0733 55.5716 12.5959 55.5716 9.98929C55.5716 7.49037 53.5251 4.90527 50.703 4.90527H44.2188V20.2004H47.1916ZM47.1916 7.51191H50.5091C51.5647 7.51191 52.5557 8.41669 52.5557 9.98929C52.5557 11.4973 51.7371 12.4667 50.6384 12.4667H47.1916V7.51191Z"
        fill="#2F363E"
      />
      <path
        d="M60.5715 20.2004V15.0733H63.5013L66.7111 20.2004H70.0717L66.4741 14.4486C68.1544 13.7377 69.2315 11.9497 69.2315 9.98929C69.2315 7.49037 67.185 4.90527 64.363 4.90527H57.5986V20.2004H60.5715ZM60.5715 7.51191H64.1691C65.2247 7.51191 66.2371 8.56749 66.2371 9.98929C66.2371 11.368 65.397 12.4667 64.2983 12.4667H60.5715V7.51191Z"
        fill="#2F363E"
      />
      <path
        d="M75.0874 17.5938V13.6084H81.5286V11.1957H75.0874V7.51191H82.5411V4.90527H72.1145V20.2004H82.735V17.5938H75.0874Z"
        fill="#2F363E"
      />
      <path
        d="M88.0886 20.2004V15.0733H91.0184L94.2282 20.2004H97.5888L93.9912 14.4486C95.6715 13.7377 96.7487 11.9497 96.7487 9.98929C96.7487 7.49037 94.7021 4.90527 91.8801 4.90527H85.1157V20.2004H88.0886ZM88.0886 7.51191H91.6862C92.7418 7.51191 93.7543 8.56749 93.7543 9.98929C93.7543 11.368 92.9141 12.4667 91.8154 12.4667H88.0886V7.51191Z"
        fill="#2F363E"
      />
      <path
        d="M102.604 17.5938V13.6084H109.046V11.1957H102.604V7.51191H110.058V4.90527H99.6316V20.2004H110.252V17.5938H102.604Z"
        fill="#2F363E"
      />
      <path
        d="M123.469 20.2004H125.881V4.92682H122.909V14.9441L114.938 4.90527H112.633V20.2004H115.606V10.3986L123.469 20.2004Z"
        fill="#2F363E"
      />
      <path
        d="M134.621 20.2004C139.21 20.2004 142.161 17.1629 142.161 12.5313C142.161 8.30898 139.619 4.90527 134.621 4.90527H129.063V20.2004H134.621ZM139.167 12.5313C139.167 15.418 137.551 17.5938 134.621 17.5938H132.036V7.51191H134.621C137.508 7.51191 139.167 9.57998 139.167 12.5313Z"
        fill="#2F363E"
      />
      <path
        d="M147.499 17.5938V13.6084H153.94V11.1957H147.499V7.51191H154.952V4.90527H144.526V20.2004H155.146V17.5938H147.499Z"
        fill="#2F363E"
      />
      <path
        d="M160.5 20.2004V15.0733H163.43L166.639 20.2004H170L166.402 14.4486C168.083 13.7377 169.16 11.9497 169.16 9.98929C169.16 7.49037 167.113 4.90527 164.291 4.90527H157.527V20.2004H160.5ZM160.5 7.51191H164.097C165.153 7.51191 166.165 8.56749 166.165 9.98929C166.165 11.368 165.325 12.4667 164.227 12.4667H160.5V7.51191Z"
        fill="#2F363E"
      />
    </svg>
  );
}

export default PrerenderLogo;
